<div (click)="appClicked()" (keyup)="appClicked()">
  @let hideChrome = (isMaintenanceRoute$ | async);
  <!--Header Start-->
  <div #fixedTop class="fixed-top">
    @if (!hideChrome) {
      <!-- Full-width headers -->
      <header-nav></header-nav>
      <header-sales></header-sales>
      <!-- Container-width headers -->
      @if (showSearchHeader$ | async) {
        <header-search></header-search>
      }
    }
  </div>
  <!--//Header End-->

  <div #fixedBottom class="fixed-bottom">
    @if (!hideChrome) {
      <pc-footer></pc-footer>
    }
  </div>

  @if (!hideChrome) {
    <div class="proactivechat-position">
      <proactive-chat></proactive-chat>
    </div>
  }

  <!-- show loading bar or circle -->
  <pc-loader></pc-loader>

  <!-- alert toast -->
  <pc-toast></pc-toast>

  <div class="parts container "
    [class.bg-light2]="!hideChrome"
    [class.maintenance-host]="hideChrome"
    [class.full-width]="(isFullSizeWidth$ | async) || hideChrome"
    [ngStyle]="{ 'margin-top.px': fixedTop.offsetHeight, 'margin-bottom.px': fixedBottom.offsetHeight }">
    <router-outlet></router-outlet>
  </div>
</div>
